import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { createFormContext } from '@coveord/plasma-mantine';
var _createFormContext = _sliced_to_array(createFormContext(), 3);
export var FrequencyFormProvider = _createFormContext[0], useFrequencyForm = _createFormContext[1], useForm = _createFormContext[2];

//# sourceMappingURL=FrequencyContext.js.map